import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import { Button, RichText } from '@marriott/mi-ui-library';
// TODO: adding types post implementation
// import { ReportMissingStayRequestConfirmationProps } from './ReportMissingStayRequestConfirmation.types';
import { scrollToClass } from '../../modules/utils';
import { MISSING_STAY_CONFIRMATION_PAGE_PATH } from '../../modules/utils/constants/constants';
import { useAccountCommonStore } from '../../modules/store/accountCommonStore';
import { StyledReportMissingStayRequestConfirmation } from './ReportMissingStayRequestConfirmation.styles';

// TODO: adding custom props types for the Component
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ReportMissingStayRequestConfirmation = ({ model }: any) => {
  const { showConfirmationSuccess } = useAccountCommonStore(store => store);
  const router = useRouter();
  const isConfirmationPage = router.pathname?.includes(MISSING_STAY_CONFIRMATION_PAGE_PATH);

  useEffect(() => {
    if (showConfirmationSuccess) {
      scrollToClass();
    }
  }, [showConfirmationSuccess]);
  return (
    <StyledReportMissingStayRequestConfirmation
      className="color-scheme3"
      data-component-name="o-account-missingstayrequestconfirmation"
      data-testid="missingstayrequestconfirmation"
      id="missing-stay-confirmation"
    >
      {showConfirmationSuccess || isConfirmationPage ? (
        <div className="pt-4 px-0">
          <div className="container color-scheme1 request-confirmation rounded p-0">
            <div className="request-confirmation__heading t-subtitle-xl px-5 py-4">{model?.header}</div>
            <hr className="request-confirmation__line m-0" />
            <div className="request-confirmation__notification mx-5 mt-4">
              <div className="m-message-inline success col-12">
                <div className="m-message-content-wrap">
                  <div className="m-message-content">
                    <span>{model?.successBanner}</span>
                  </div>
                </div>
              </div>
            </div>
            <RichText
              text={model?.informationSection}
              componentId="info-section"
              customClass="request-confirmation__body px-5 py-4"
            />
            <div className="px-5 pb-5 next-link-container">
              <Button
                href={model?.ctaPath}
                className="request-confirmation__next-link m-link-tertiary-button"
                isLink={true}
              >
                {model?.ctaLabel}&nbsp;
              </Button>
            </div>
          </div>
          <div className="container request-confirmation-link next-link-container mt-5">
            <Button
              href={model.secondaryCtaPath}
              className="request-confirmation__next-link m-link-back-tertiary-button mx-0"
              isLink={true}
            >
              &nbsp;
              {model.secondaryCtaLabel}
            </Button>
          </div>
        </div>
      ) : null}
    </StyledReportMissingStayRequestConfirmation>
  );
};

export const ReportMissingStayRequestConfirmationConfig = {
  emptyLabel: 'reportMissingStayRequestConfirmation',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/missingstayrequestconfirmation`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ReportMissingStayRequestConfirmationEditable = (props: any) => (
  <EditableComponent config={ReportMissingStayRequestConfirmationConfig} {...props}>
    <ReportMissingStayRequestConfirmation {...props} />
  </EditableComponent>
);
